import { Page, Content } from '@backstage/core-components';
import {
  HomePageStarredEntities,
  HomePageToolkit,
  CustomHomepageGrid,
  HomePageRandomJoke,
  HomePageTopVisited,
  HomePageRecentlyVisited,
} from '@backstage/plugin-home';
import { HomePageSearchBar } from '@backstage/plugin-search';
import { Grid } from '@material-ui/core';
import { tools } from './shared';

import logoServi from '../Root/logo/LogoServi.png';
const LogoHome = () => {
  return <img src={logoServi} height={"80px"} style={{ margin: "20px" }} />;
};

const defaultConfig = [
  {
    component: 'HomePageSearchBar',
    x: 0,
    y: 0,
    width: 24,
    height: 2,
  },
  {
    component: 'HomePageRecentlyVisited',
    x: 0,
    y: 1,
    width: 5,
    height: 4,
  },
  {
    component: 'HomePageTopVisited',
    x: 5,
    y: 1,
    width: 5,
    height: 4,
  },
  {
    component: 'HomePageStarredEntities',
    x: 0,
    y: 2,
    width: 6,
    height: 4,
  },
  {
    component: 'HomePageToolkit',
    x: 6,
    y: 6,
    width: 4,
    height: 4,
  },
];

export const CustomizableHomePage = () => {
  // const { svg, path, container } = useLogoStyles();

  return (
    <Page themeId="home">
      <Content>

        <Grid container item xs={12} justifyContent="center"
        style={{
          backgroundColor: "#333",
          background: "radial-gradient(circle,rgba(51, 51, 51, 1) 0%, rgba(153, 153, 153, 1) 100%)",
          }}>
        <LogoHome />
        </Grid>

        <CustomHomepageGrid config={defaultConfig} preventCollision={false}>
          <HomePageSearchBar />
          <HomePageRecentlyVisited />
          <HomePageTopVisited />
          <HomePageToolkit tools={tools} />
          <HomePageStarredEntities />
          <HomePageRandomJoke />
        </CustomHomepageGrid>
      </Content>
    </Page>
  );
};
